module.exports = __webpack_public_path__ + "img/Processeding.74829a72.png";